import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price: number): string {
  return new Intl.NumberFormat('nl-BE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
}

export function formatCompactPrice(price: number | null | undefined): string {
  if (price == null) return '€ —';
  if (price >= 1000000) {
    return `€${(price / 1000000).toFixed(1).replace('.0', '')}M`;
  } else if (price >= 1000) {
    return `€${(price / 1000).toFixed(0)}k`;
  }
  return `€${price}`;
}

export function bytesToSize(bytes: number): string {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString());
  return Math.round((bytes / Math.pow(1024, i)) * 100) / 100 + ' ' + sizes[i];
}

export function formatTime(date: Date): string {
  return date.toLocaleTimeString(['nl-BE'], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Europe/Brussels'
  }).replaceAll(/(a\.m\.|p\.m\.)/gi, (match) =>
    match.replaceAll('.', '').trim().toUpperCase()
  );
}

